import { matchRoutes, useLocation } from 'react-router-dom'
import routers from '@/routes'
import { useMemo } from 'react'

export const useCurrentRouter = () => {
  const location = useLocation()
  const match = useMemo(() => matchRoutes(routers, location.pathname) || [], [location.pathname])
  return match
}
